import { useMutation, useQuery } from '@tanstack/react-query';
import APIService from '../APIService';
import { useDispatch } from 'react-redux';
import { SET_USER, UPDATE_USER_SUCCESS } from '../../state/constants';

const useUser = () => {
  const dispatch = useDispatch();
  return useQuery({
    queryKey: ['user'],
    queryFn: async () => {
      const user = await APIService.GET('/user');
      dispatch({ type: SET_USER, user: user.data });
      return user.data;
    },
  });
};

const useUpdateUser = () => {
  const { data: user } = useUser();
  const dispatch = useDispatch();
  return useMutation({
    mutationFn: async (updates: any) => {
      const updatedUser = await APIService.PUT(`/user/${user._id}`, undefined, updates);
      dispatch({ type: UPDATE_USER_SUCCESS, user: updatedUser.data });
      return updatedUser.data;
    },
  });
};

const useOrgMember = ({ orgPath }: { orgPath: string }) => {
  const { data: user } = useUser();
  return user?.orgs?.find((org: any) => org.url === orgPath)?.members?.[user?._id];
};

const useConfirmUser = () => {
  return useMutation({
    mutationFn: async ({ code, userName, clientId }: { code: string; userName: string; clientId: string }) => {
      return APIService.POST('/auth/verify', undefined, {
        code,
        userName,
        clientId,
      });
    },
  });
};

const useFinalizeAccount = () => {
  return useMutation({
    mutationFn: async ({
      userName,
      userPoolId,
      firstName,
      lastName,
    }: {
      userName: string;
      userPoolId: string;
      firstName: string;
      lastName: string;
    }) => {
      return APIService.POST('/auth/finalizeAccount', undefined, {
        userName,
        userPoolId,
        firstName,
        lastName,
      });
    },
  });
};

export { useOrgMember, useUpdateUser, useConfirmUser, useFinalizeAccount };

export default useUser;
